import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const RedBorderCloseIcon = () => {
  return (
    <IconButton
      style={{
        border: "1px solid red",  // Red border
        borderRadius: "30%",      // Circle shape
        padding: "1px",           // Padding inside the circle
        display: "flex",          // Ensure content is centered
        justifyContent: "center", // Center the icon inside the circle
        alignItems: "center",     // Center the icon vertically
        width: "15px",            // Set width of the IconButton
        height: "15px",           // Set height of the IconButton
      }}
    >
      <CloseIcon style={{ color: "red", fontSize: "10px" }} />
    </IconButton>
  );
};

export default RedBorderCloseIcon;
